import github from '../asset/github.svg';
import linkedln from '../asset/linkedin.svg';
import codepen from '../asset/codepen.svg';

const contact = [
    {
        name: 'github',
        link: 'https://github.com/Willy-tec',
        imgLink: github,
    },
    {
        name: 'linkedln',
        link: 'https://www.linkedin.com/in/wastiaux-william-74352b224/',
        imgLink: linkedln,
    },
    {
        name: 'codepen',
        link: 'https://codepen.io/willytec',
        imgLink: codepen,
    },
];
export default contact;
